import { useUser } from '@/features/account/services/User/hooks'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { useStoreParams, type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { useQuery } from '@tanstack/react-query'
import { experimentsQueryOptions } from '@/features/shared/services/Experiments/queryOptions'

export type ExperimentsQueryKey = [string, ExperimentParams]

type ExperimentParams = {
  storeParams: StoreParams | undefined
  has_purchased: boolean | undefined
  has_placed_first_order: boolean | undefined
  has_placed_marketplace_order: boolean
  has_subscription: boolean
  has_shipt_email: boolean
  is_exempt: boolean
  plan_id: string | undefined
  user_id: number | undefined
  subscription_type: string | undefined | null
}

export const useQueryExperiments = ({ enabled = true } = {}) => {
  const storeParams = useStoreParams()
  const user = useUser()
  const { isSessionLoading, isSessionValid } = useSession()

  return useQuery({
    ...experimentsQueryOptions({ storeParams, user }),
    placeholderData: (previousData) => previousData,
    // isSessionValid == false for guest and new user.
    // isSessionValid == true for logged in user. id truthiness indicates whether we're currently fetching user or not.
    // We don't want to fetch experiments for a logged in user until we fetch user details
    enabled: enabled && !isSessionLoading && (!isSessionValid || Boolean(user?.id)),
  })
}
